import { render, staticRenderFns } from "./BatchStatisticsDialog.vue?vue&type=template&id=5bc77619&scoped=true&"
import script from "./BatchStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./BatchStatisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchStatisticsDialog.vue?vue&type=style&index=0&id=5bc77619&scoped=true&lang=scss&"
import style1 from "./BatchStatisticsDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc77619",
  null
  
)

export default component.exports